// Generated by pnpm --filter @langfuse/icons generate. Do not edit.
import { createIcon } from "../../create-icon.js";
import { ImageOff as RawImageOff } from "lucide-react";
export const ImageOff = /* @__PURE__ */ createIcon(RawImageOff, "ImageOff", 2);
